import { SchedulingAvailabilityGridHeaderCell } from "../SchedulingAvailabilityGridHeaderCell";

export type Props = {
  /** Array of pre-formatted header strings with timezone abbreviation (e.g., "Jan 14 PST") */
  headers: string[];
};

export function SchedulingAvailabilityGridHeaderRow({ headers }: Props) {
  return (
    <div role="row" className="contents">
      {/* Spacer cell for the time column */}
      <SchedulingAvailabilityGridHeaderCell className="h-auto pb-1 text-center sticky left-0 bg-brand-50 z-30" />

      {/* Date headers */}
      {headers.map((header, index) => (
        <SchedulingAvailabilityGridHeaderCell
          className="h-auto pb-1 pt-7 text-center"
          key={`header-${index}`}
        >
          {header}
        </SchedulingAvailabilityGridHeaderCell>
      ))}
    </div>
  );
}

export default SchedulingAvailabilityGridHeaderRow;

